<template>
    <div>
        <div class="head">
            <p class="title">申报信息</p>
            <van-button type="primary" size="mini" @click="passActive(0)">修改</van-button>
        </div>
        <van-cell-group>
            <van-cell title="公安机关" :value="informationShowData.deptName"/>
            <van-cell title="申请人" :value="informationShowData.name"/>
            <van-cell title="身份证号码" :value="informationShowData.idNum"/>
            <van-cell title="联系地址" :value="informationShowData.address"/>
            <van-cell title="联系电话" :value="informationShowData.phone"/>
            <slot></slot>
        </van-cell-group>
        <div v-if="informationShowData.isUpload">
            <div class="head">
                <p class="title">附件上传</p>
                <van-button type="primary" size="mini" @click="passActive(1)">修改</van-button>
            </div>
            <van-cell-group>
                <van-cell class="upload-image-title" :title="item.title" v-for="(item, index) in previewImageList" :key="index">
                    <ul class="upload-image-container" v-if="item.url.length">
                        <li class="image-list-container" v-for="(imageItem, imageIndex) in item.url" :key="imageIndex">
                            <div class="image-delete-div">
                                <img :src="imageItem" class="img-list" @click="amplification(imageItem)"/>
                            </div>
                        </li>
                    </ul>
                    <div v-else>未上传附件</div>
                </van-cell>
            </van-cell-group>
        </div>
        <div v-if="informationShowData.mailingShow === 'Y'">
            <div class="head">
                <p class="title">办理方式</p>
                <van-button type="primary" size="mini" @click="passActive(2)">修改</van-button>
            </div>
            <div v-if="informationShowData.mailingStatus==='2' || informationShowData.mailingStatus==='3'">
                <van-cell title="取件地址"
                          :value="`${informationShowData.takeData.provinceName}${informationShowData.takeData.cityName}${informationShowData.takeData.areaName}${informationShowData.takeData.adderss}`"/>
                <van-cell title="取件人" :value="informationShowData.takeData.addressee"/>
                <van-cell title="取件联系电话" :value="informationShowData.takeData.addresseeTel"/>
                <van-cell title="取件费用" :value="informationShowData.takePrice"/>
            </div>
            <div v-if="informationShowData.mailingStatus==='2' || informationShowData.mailingStatus==='1'">
                <van-cell title="收件地址"
                          :value="`${informationShowData.receiveData.provinceName}${informationShowData.receiveData.cityName}${informationShowData.receiveData.areaName}${informationShowData.receiveData.adderss}`"/>
                <van-cell title="收件人" :value="informationShowData.receiveData.addressee"/>
                <van-cell title="收件联系电话" :value="informationShowData.receiveData.addresseeTel"/>
                <van-cell title="收件费用" :value="informationShowData.receivePrice"/>
            </div>
            <van-cell title="工本费" :value="informationShowData.totalPrice"/>
        </div>
    </div>
</template>

<script>
  /**
   * Description: 事项信息展示
   * Author: wangyan
   * Date: 2019-05-13
   * Time: 11:12
   */

  import { CellGroup, Cell, Button, ImagePreview } from 'vant'

  export default {
    name: "InformationShow",
    components: {
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Button.name]: Button,
      [ImagePreview.name]: ImagePreview
    },
    props: {
      informationShowData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        previewImageList: [],
        port: global.imageUrl,
        amplificationImg: null,
      }
    },
    watch: {
      informationShowData: {
        handler(val) {
          this.previewImageList = []
          for (let index in val.imageTitleList) {
            this.previewImageList.push({
              title: val.imageTitleList[index].itemName,
              url: []
            })
            for (let iamgeIndex in val.imageList) {
              if (val.imageTitleList[index].guid === val.imageList[iamgeIndex].titleGuid) {
                this.previewImageList[index].url.push(global.imageUrl + val.imageList[iamgeIndex].url)
              }
            }
          }
        },
        deep: true
      }
    },
    methods: {
      passActive(index) {
        if (index === 1) {
          this.informationShowData.imageList = []
        }
        this.$emit('setActive', index)
      },
      amplification(url) {
        this.amplificationImg = ImagePreview({
          images: [url],
          showIndex: false,
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .head {
        overflow: hidden;
        padding: 0.2rem 0.3rem;
        .display-flex;
        .align-items;
        .justify-content(space-between);

        .title {
            color: #808080;
        }

    }

    .upload-image-title {
        flex-direction: column;
        -webkit-flex-direction: column;
        align-items: baseline;
        -webkit-align-items: baseline;
    }

    .upload-image-container {
        width: 100%;
        text-align: left;
        margin-top: 0.1rem;
    }

    .image-list-container {
        display: inline-block;
    }

    .image-delete-div {
        position: relative;
    }

    .img-list {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.3rem;
        margin-top: 0.26666rem;
        margin-right: 0.23rem;
    }
</style>
